import { render, staticRenderFns } from "./CalcFormulaConfig.vue?vue&type=template&id=115ae967&scoped=true"
import script from "./CalcFormulaConfig.vue?vue&type=script&lang=js"
export * from "./CalcFormulaConfig.vue?vue&type=script&lang=js"
import style0 from "./CalcFormulaConfig.vue?vue&type=style&index=0&id=115ae967&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ae967",
  null
  
)

export default component.exports